import axios from 'axios';
import apiConfig from '../api.config';

export default async function customerListRequest({ ownerId }) {
  const {
    host,
    URIs: { customerList },
  } = apiConfig;

  const uri = `${host}${customerList}/${ownerId}`;

  const res = await axios.get(uri, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data;
}
